import { types } from "../action-types";

const S3_URL = process.env.REACT_APP_S3_URL || "";

const getEstimatedAmount = (item) => {
  try {
    const minimumBid = item?.MinimumBid;
    const rawAmount =
      minimumBid && typeof minimumBid === "object"
        ? minimumBid.$numberDecimal
        : minimumBid;
    const amount = Number(rawAmount);

    if (rawAmount === null || rawAmount === undefined || rawAmount === "") {
      return "";
    }
    if (!Number.isFinite(amount)) return "";

    const rawRatePeriod =
      item?.MinimumBidType || item?.BudgetTypes?.BudgetTypeName || "";
    const ratePeriod =
      typeof rawRatePeriod === "string" || typeof rawRatePeriod === "number"
        ? String(rawRatePeriod).trim()
        : "";
    const formattedAmount = amount.toLocaleString("en-US", {
      maximumFractionDigits: 2,
    });

    return `$${formattedAmount}${ratePeriod ? `/${ratePeriod}` : ""}`;
  } catch {
    return "";
  }
};

const normalizeItem = (item) => {
  const profiles = item?.users?.Profiles || {};
  const firstName = profiles.FirstName || "";
  const lastName = profiles.LastName || "";
  const pictureUrl = profiles.PictureUrl;

  return {
    ...item,
    _id: item._id,
    id: item.SkillListingId,
    SkillListingId: item.SkillListingId,
    name: `${firstName} ${lastName}`.trim() || "Unknown",
    title: item.Title || "",
    avatar: pictureUrl
      ? pictureUrl.startsWith("http")
        ? pictureUrl
        : `${S3_URL}/${pictureUrl}`
      : null,
    initials: firstName && lastName ? `${firstName[0]}${lastName[0]}` : "?",
    online: false,
    status: "available",
    rating: parseFloat(profiles.Rating) || 0,
    reviewCount: profiles.Review || 0,
    estimatedAmount: getEstimatedAmount(item),
    experience:
      profiles.ExperienceLevelName ||
      profiles.ExperienceLevels?.ExperienceLevelName ||
      item.explevel?.[0]?.ExperienceLevelName ||
      "",
    location: (() => {
      const city = item.SkillListings_Cities?.[0];
      return city?.Cities?.LocationWithCountry || city?.LocationWithCountry || "";
    })(),
    bidId: item.bidId,
    bidStatusId: item.bidStatusId,
    bidStatus: item.bidStatus,
    bidStatusName: item.bidStatusName,
    bidProfileId: item.bidProfileId,
  };
};

const initialState = {
  loading: false,
  error: false,
  data: [],
  totalCount: 0,
};

const queryPageSkillListingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SEARCH_SKILLLISTING_QUERY_INIT:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case types.SEARCH_SKILLLISTING_QUERY_SUCCESS: {
      const graphQlResult = action.payload?.data?.skilllistings;
      const rawList = Array.isArray(action.payload?.data)
        ? action.payload.data
        : graphQlResult?.data || [];
      return {
        ...state,
        loading: false,
        error: false,
        data: rawList.map(normalizeItem),
        totalCount:
          action.payload?.pagination?.totalCount ||
          graphQlResult?.aggregate?.totalCount ||
          rawList[0]?.TotalCount?.count?.total ||
          rawList.length ||
          0,
      };
    }
    case types.SEARCH_SKILLLISTING_QUERY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
        totalCount: 0,
      };
    default:
      return state;
  }
};

export default queryPageSkillListingReducer;
